<template>
  <div style="background-color: #f2f2f2;height: 100%;">
    <div
      style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;"
    >小乐手表</div>
    <div style="padding: 20px;">
      <div>
        <el-row>
          <el-button type="primary" plain @click.native="toggleModalAdd">绑定设备</el-button>
          <div style="float:right">
            <el-input
              placeholder="请输入老人姓名"
              v-model="name"
              clearable
              style="margin:0 5px;width:200px"
            ></el-input>
            <el-input
              placeholder="请输入Imei号"
              v-model="imei"
              clearable
              style="margin:0 5px;width:200px"
            ></el-input>
            <el-input
              placeholder="请输入手机号"
              v-model="phone"
              clearable
              style="margin:0 5px;width:200px"
            ></el-input>
            <!-- <span class="demonstration" >所属区域：</span> -->
            <!-- <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
            placeholder="请选择所属区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                          style="width:200px;margin-right:10px"></elSelectTree> -->
            <el-button
              style="margin-left:10px;float:right"
              type="primary"
              icon="el-icon-search"
              @click="getList(true)"
            >搜索</el-button>
          </div>
        </el-row>

        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>
          <el-table v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">
            <el-table-column prop="elderlyName" label="用户姓名"></el-table-column>

            <el-table-column prop="phone" label="手机号"></el-table-column>

            <el-table-column prop="imei" label="Imei号"></el-table-column>

            <!-- <el-table-column prop="zoneCodePathName" label="组织" width="200" ></el-table-column> -->

            <el-table-column prop="bindTime" label="绑定时间" :formatter="timefilter"></el-table-column>

            <el-table-column fixed="right" label="操作" width="230px">
              <template slot-scope="scope">
                <el-button type="primary" size="small"   @click="setData(scope.$index, scope.row)"  >设置 </el-button>
                <el-button type="success" size="small"  @click="getWatchData(scope.$index, scope.row)"  >数据 </el-button>
                <el-button type="danger" size="small" @click="RemoveBinding(scope.row)">解绑</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div
              style="float: left;padding: 5px;"
            >共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change"
              ></el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>
        </template>
      </div>
    </div>
    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false"  v-on:getList="getList"></Add>
    <SOSSetPage ref="mySOSSetPage"  v-show="showModalSOSSetPage"  v-on:closeSOSSetPage="closeSOSSetPage"></SOSSetPage>
    <WatchData ref="WatchData"  v-show="watchDataShow"  v-on:closeWatchData="closeWatchData"></WatchData>
  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";

import { getInstitutionCode } from "@/utils/auth";
import SOSSetPage from "./SOS/SOSSetPage";
import WatchData from "./WatchData/WatchData";
import Add from "./Add";
// import elSelectTree from "@/components/ElSelectTree";
export default {
  name: "Role",
  data() {
    return {
      tableLoading:false,
      tableData: null,
      showModalAdd:false,
      showModalSOSSetPage:false,
      watchDataShow:false,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: 0,
      name:"",
      phone: "",
      imei: "",
      zoneCode: '',
    };
  },
  components:{
    Add,
      SOSSetPage,WatchData
      // ,elSelectTree
  },
  created() {
    // this.init();
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {
    init: function () {
    },
    getZoneValue(val) {
                this.zoneCode = val
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    toggleModalAdd: function () {
        this.showModalAdd = !this.showModalAdd;
        this.$refs.myAdd.init();
    },
    closeGetElderly: function () {
        this.showModalGetElderly = !this.showModalGetElderly;
    },
    getWatchData(index,row){
      this.$refs.WatchData.init(row);
      this.watchDataShow =!this.watchDataShow;
    },
    closeWatchData(){
      this.watchDataShow =!this.watchDataShow;
    },
    setData(index,row){

        this.$refs.mySOSSetPage.init(row);
        this.showModalSOSSetPage = !this.showModalSOSSetPage;
    },
    closeSOSSetPage(){
      this.showModalSOSSetPage =!this.showModalSOSSetPage;
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true
      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceTogWatch/PageByGovernmentCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          // staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          governmentCode:getInstitutionCode(),
          name:this.name,
          phone: this.phone,
          imei: this.imei,
          pageSize: this.pageSize,
          zoneCode:this.zoneCode
        },
      })
        .then((response) => {
          _this.tableLoading=false
          if (response.data.error == 0) {
            this.tableData = response.data.data.list;
            this.totalItems = response.data.data.total;
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          _this.tableLoading=false
          console.log(error);
        });
    },

    //日期格式
    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
            this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceTogWatch/RemoveBinding",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          userCode: row.userCode,
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            this.$message({
              message: "解绑成功",
              type: "success",
            });
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
  },
};
</script>

<style scoped>
</style>
